import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Pagination from '../Pagination/Pagination';
import { updateFilter, resetFilter, clearFilter, updatePagination } from '../../actions/environment';
import { intersect, unique } from '../../utils/array';
import { fixBackgroundScroll, hasClass, addEvent, removeEvent } from '../../utils/dom';
import { translate, prefix } from '../../utils/locale';
import { deepCompare } from '../../utils/object';
import { pascalCase } from '../../utils/string';
import s from './Filter.scss';

class Filter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filterOpen: false,
			sortOpen: false,
			colors: false,
			washes: false,
			styles: false,
			rise: false,
			stretch: false,
			sizes: false,
			sort: false,
			screenHeight: typeof window !== 'undefined' ? `${window.innerHeight - 86}px` : 'calc(100vh - 86px)',
			hash: typeof window !== 'undefined' ? window.location.hash : '',
		};

		this.filterTools = React.createRef();
	}

	componentDidMount() {
		if (this.state.hash) {
			const hashFilter = [];
			this.state.hash.slice(1).split('&').forEach((filterPart) => {
				const filterParts = filterPart.split('=');
				if (filterParts.length === 1) {
					hashFilter.push({ [filterParts[0]]: true });
				} else {
					hashFilter.push({ [filterParts[0]]: filterParts[1].split(',') });
				}
			});

			this.props.updateFilter(hashFilter, true, this.props.setup, this.props.currentPath);
			this.setState({ hash: null });
		}

		const updateWindowHeight = () => {
			this.setState({ screenHeight: `${window.innerHeight - 86}px` });
		};

		addEvent(window, 'resize.toolbar', () => {
			window.requestAnimationFrame(updateWindowHeight);
		});
	}

	componentWillUnmount() {
		removeEvent(window, 'resize.toolbar');
	}

	handleToggleDropdown = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;

		if ($link.getAttribute('href') === '#open-filter') {
			this.setState((prevState) => {
				if (prevState.filterOpen) {
					window.setTimeout(() => {
						this.setState({
							colors: false,
							washes: false,
							styles: false,
							rise: false,
							stretch: false,
							sizes: false,
						});
					}, 700);
				}
				fixBackgroundScroll(!prevState.filterOpen);
				return {
					filterOpen: !prevState.filterOpen,
					sortOpen: false,
					screenHeight: `${window.innerHeight - 86}px`,
				};
			});
		} else if ($link.getAttribute('href') === '#open-sort') {
			this.setState((prevState) => {
				fixBackgroundScroll(!prevState.sortOpen);
				return {
					sortOpen: !prevState.sortOpen,
					filterOpen: false,
					screenHeight: `${window.innerHeight - 86}px`,
				};
			});
		} else {
			fixBackgroundScroll(false);
			this.setState({
				sortOpen: false,
				filterOpen: false,
			});
		}
	}

	handleClearFilter = (e) => {
		e.preventDefault();
		this.props.clearFilter();
		this.props.updatePagination(this.props.currentPath, 1);
		this.resetFilterDropdowns();
	}

	resetFilterDropdowns = (e) => {
		if (e) e.preventDefault();
		this.setState({
			colors: false,
			washes: false,
			styles: false,
			rise: false,
			stretch: false,
			sizes: false,
			sort: false,
			sortOpen: false,
			filterOpen: false,
		});
		fixBackgroundScroll(false);
		if (window.innerWidth <= 600) {
			window.scrollTo(0, 0);
		}
	}

	handleToggleGroup = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;
		const whichGroup = $link.dataset.group;
		const nextState = {
			colors: false,
			washes: false,
			styles: false,
			rise: false,
			stretch: false,
			sizes: false,
			sort: false,
			screenHeight: `${window.innerHeight - 86}px`,
		};

		this.setState((prevState) => {
			if (!prevState[whichGroup]) nextState[whichGroup] = true;
			return nextState;
		});
	}

	handleFilterUpdate = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;
		const action = $link.getAttribute('href');
		const filterType = action.indexOf('#') === 0 ? action.slice(1, action.indexOf('=')) : 'categories';
		const filterValue = action.indexOf('#') === 0 ? action.slice(action.indexOf('=') + 1) : action.replace(prefix(this.props.setup, ''), '');

		this.props.updateFilter([{ [filterType]: filterValue }], false, this.props.setup, this.props.currentPath);
		this.props.updatePagination(this.props.currentPath, 1);

		if (hasClass(document.body, 'u_backgroundFixed')) document.body.style.top = '0px';

		if (filterType === 'sort') {
			this.setState({
				sortOpen: false,
			});
			fixBackgroundScroll(false);
		}
	}

	render() {
		const { ListComponent, data, filtering, setup, filter, currentPath, collectionSections, contentOffset } = this.props;
		const { filterOpen, sortOpen, screenHeight } = this.state;

		// how to update filterHash on page load???

		const { filterArrays, filterDescriptions, localized, products } = filtering;
		const isLocalized = localized[setup.language];
		const isFiltered = !deepCompare(filter.clearFilterBase, filter.filteredBy) || !!filter.sort;

		if (!filter.currentFilterSegment) return null;

		// Category paths are localized.
		const categories = isLocalized ? Object.keys(filterArrays.categories).reduce((acc, category) => {
			const categoryKey = isLocalized.categories[category] ? isLocalized.categories[category].key : category;
			return ({ ...acc, [categoryKey]: [...filterArrays.categories[category]] });
		}, {}) : filterArrays.categories;

		// Localize colors
		const colors = isLocalized ? Object.keys(filterArrays.colors).reduce((acc, color) => {
			const colorkey = isLocalized.colors[color] ? isLocalized.colors[color].key : color;
			return ({ ...acc, [colorkey]: [...filterArrays.colors[color]] });
		}, {}) : filterArrays.colors;

		const colorDescriptions = isLocalized ? Object.keys(filterArrays.colors).reduce((acc, color) => {
			const colorKey = isLocalized.colors[color] ? isLocalized.colors[color].key : color;
			const colorDescription = isLocalized.colors[color] ? isLocalized.colors[color].text : filterDescriptions.colors[color];
			return ({ ...acc, [colorKey]: colorDescription });
		}, {}) : filterDescriptions.colors;

		// Localize styles
		const styles = isLocalized ? Object.keys(filterArrays.styles).reduce((acc, style) => {
			const stylekey = isLocalized.styles[style] ? isLocalized.styles[style].key : style;
			return ({ ...acc, [stylekey]: [...filterArrays.styles[style]] });
		}, {}) : filterArrays.styles;

		const styleDescriptions = isLocalized ? Object.keys(filterArrays.styles).reduce((acc, style) => {
			const styleKey = isLocalized.styles[style] ? isLocalized.styles[style].key : style;
			const styleDescription = isLocalized.styles[style] ? isLocalized.styles[style].text : filterDescriptions.styles[style];
			return ({ ...acc, [styleKey]: styleDescription });
		}, {}) : filterDescriptions.styles;

		// Localize rise
		const rise = isLocalized ? Object.keys(filterArrays.rise).reduce((acc, r) => {
			const riseKey = isLocalized.rise[r] ? isLocalized.rise[r].key : r;
			return ({ ...acc, [riseKey]: [...filterArrays.rise[r]] });
		}, {}) : filterArrays.rise;

		const riseDescriptions = isLocalized ? Object.keys(filterArrays.rise).reduce((acc, r) => {
			const riseKey = isLocalized.rise[r] ? isLocalized.rise[r].key : r;
			const riseDescription = isLocalized.rise[r] ? isLocalized.rise[r].text : filterDescriptions.rise[r];
			return ({ ...acc, [riseKey]: riseDescription });
		}, {}) : filterDescriptions.rise;

		// Localize stretch
		const stretch = isLocalized ? Object.keys(filterArrays.stretch).reduce((acc, r) => {
			const stretchKey = isLocalized.stretch[r] ? isLocalized.stretch[r].key : r;
			return ({ ...acc, [stretchKey]: [...filterArrays.stretch[r]] });
		}, {}) : filterArrays.stretch;

		const stretchDescriptions = isLocalized ? Object.keys(filterArrays.stretch).reduce((acc, r) => {
			const stretchKey = isLocalized.stretch[r] ? isLocalized.stretch[r].key : r;
			const stretchDescription = isLocalized.stretch[r] ? isLocalized.stretch[r].text : filterDescriptions.stretch[r];
			return ({ ...acc, [stretchKey]: stretchDescription });
		}, {}) : filterDescriptions.stretch;

		// Localize washes
		const washes = isLocalized ? Object.keys(filterArrays.washes).reduce((acc, wash) => {
			const washkey = isLocalized.washes[wash] ? isLocalized.washes[wash].key : wash;
			return ({ ...acc, [washkey]: [...filterArrays.washes[wash]] });
		}, {}) : filterArrays.washes;

		const washDescriptions = isLocalized ? Object.keys(filterArrays.washes).reduce((acc, wash) => {
			const washKey = isLocalized.washes[wash] ? isLocalized.washes[wash].key : wash;
			const washDescription = isLocalized.washes[wash] ? isLocalized.washes[wash].text : filterDescriptions.washes[wash];
			return ({ ...acc, [washKey]: washDescription });
		}, {}) : filterDescriptions.washes;

		/*
			Filter

			This could benefit from memoization - reselect

			Filters which don't match the base list of products are removed i.e. women men etc.
			Filters which don't match the current categories' list of products are disabled. Except categories.
		*/

		// Get base URI for filtering.
		if (data.baseUri === undefined) return null;
		let relevantBaseProducts = data.baseType === 'campaigns' ? filterArrays[data.campaignType] : (filterArrays[data.baseType][currentPath] || filterArrays[data.baseType][data.baseUri]);
		if (relevantBaseProducts === undefined) relevantBaseProducts = [];
		relevantBaseProducts = relevantBaseProducts.filter((rbp) => products[rbp] !== undefined);
		let relevantProducts = [...relevantBaseProducts];

		const filteredProducts = {};

		// Filter only relevant products
		filter.filteredBy.forEach((filterObj) => {
			const filterType = Object.keys(filterObj)[0];
			const filterItem = filterObj[filterType];
			if (filterItem === true || (Array.isArray(filterItem) && filterItem.length > 0)) {
				// Products are filtered
				// Need to update relevantProducts on every pass.
				switch (filterType) {
					case 'categories': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...(categories[type] ? categories[type] : []), ...acc], []));
						filteredProducts.categories = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'colors': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...colors[type], ...acc], []));
						filteredProducts.colors = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'sizes': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...filterArrays.sizes[type.slice(0, type.lastIndexOf('___'))][type.slice(type.lastIndexOf('___') + 3)], ...acc], []));
						filteredProducts.sizes = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'washes': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...washes[type], ...acc], []));
						filteredProducts.washes = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'styles': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...styles[type], ...acc], []));
						filteredProducts.styles = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'rise': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...rise[type], ...acc], []));
						filteredProducts.rise = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'stretch': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...stretch[type], ...acc], []));
						filteredProducts.stretch = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					default:
						break;
				}
			}
		});

		// Last filter is special so that the user can select multiple filters.
		let relevantFilterProducts = [...relevantBaseProducts];
		let relevantFilterProductsLast = [...relevantBaseProducts];
		let lastFilter = '';

		if (Object.keys(filteredProducts).length > 0) {
			// Restrict filters based on final filter in filteredBy.
			filter.filteredBy.slice(0).forEach((filterObj, i) => {
				lastFilter = Object.keys(filterObj)[0];
				if (filteredProducts[lastFilter]) {
					relevantFilterProducts = intersect(relevantFilterProducts, filteredProducts[lastFilter]);
					if (i < filter.filteredBy.length - 1) relevantFilterProductsLast = intersect(relevantFilterProductsLast, filteredProducts[lastFilter]);
				}
			});
		}

		/*
			Sorting
		*/
		if (filter.sort) {
			const sortBy = filter.sort.replace(/-(ascending|descending)$/, '');

			relevantProducts = relevantProducts.map((productId) => {
				let sortingValue = filter.sort.indexOf('descending') !== -1 ? 0 : 9999999999;
				if (products[productId].inStock === 0) return { key: productId, sort: sortingValue };

				if (sortBy === 'price') {
					sortingValue = products[productId].price.priceAsNumber;
				} else if (products[productId][sortBy]) {
					sortingValue = products[productId][sortBy];
				}
				return { key: productId, sort: sortingValue };
			}).sort((a, b) => {
				if (a.sort === b.sort) return parseInt(a.key, 10) > parseInt(b.key, 10) ? 1 : -1;
				if (filter.sort.indexOf('descending') === -1) {
					return a.sort > b.sort ? 1 : -1;
				}
				return a.sort < b.sort ? 1 : -1;
			}).map((productObject) => productObject.key);
		}

		const selectedGroup = [];
		if (this.state.styles) selectedGroup.push('styles');
		if (this.state.rise) selectedGroup.push('rise');
		if (this.state.stretch) selectedGroup.push('stretch');
		if (this.state.colors) selectedGroup.push('colors');
		if (this.state.sizes) selectedGroup.push('sizes');
		if (this.state.washes) selectedGroup.push('washes');

		const styleFilter = Object.keys(styles).filter((style) => intersect(styles[style], relevantBaseProducts).length > 0).sort((a, b) => a.localeCompare(b)).map((style) => ({ uri: `#styles=${style}`, title: styleDescriptions[style] }));

		return (
			<div className={s.filter}>
				{ (sortOpen || filterOpen) && <button className={s.filter_screen} onClick={this.handleToggleDropdown} type="button" aria-label="Close Filter Tools" /> }
				<div className={[s.filter_tools, (sortOpen || filterOpen ? s.filter_tools__open : null), (relevantBaseProducts.length === 0 ? s.filter_tools__empty : null)].join(' ')} ref={this.filterTools}>
					{/* Sort */}
					<div className={[s.filtering, (sortOpen ? s.filtering__open : null)].join(' ')}>
						<div className={s.filtering_title}>
							<a href="#open-sort" onClick={this.handleToggleDropdown}><span>{ translate(setup, 'sortOpen') }</span></a>
						</div>
						<div className={s.filtering_inner} style={{ height: screenHeight }}>
							<a className={s.filtering_inner_close} href="#close-filter" onClick={this.handleToggleDropdown}>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 1L1 13" stroke="black" />
									<path d="M1 1L13 13" stroke="black" />
								</svg>
							</a>

							<div className={s.filtering_inner_chosenItems}>
								{
									filter.sort && (
										<a className={s.filtering_inner_chosenItem} href={`#sort=${filter.sort}`} onClick={this.handleFilterUpdate}>
											{ translate(setup, `filterSort${pascalCase(filter.sort)}`) }
										</a>
									)
								}
							</div>

							<div className={s.section}>
								<div className={[s.section_group, s.section_group__open].join(' ')}>
									<a className={s.section_group_title} href="#open-group" data-group="sort" onClick={this.handleToggleGroup}>
										<span>{ translate(setup, 'filterSort') }</span>
									</a>

									{/* sorts */}
									<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
										<div className={[s.section_group_item, (filter.sort === 'added-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
											<a onClick={this.handleFilterUpdate} href="#sort=added-descending">{ translate(setup, 'filterSortAddedDescending') }</a>
										</div>
										<div className={[s.section_group_item, (filter.sort === 'price-ascending' ? [s.section_group_item__selected] : null)].join(' ')}>
											<a onClick={this.handleFilterUpdate} href="#sort=price-ascending">{ translate(setup, 'filterSortPriceAscending') }</a>
										</div>
										<div className={[s.section_group_item, (filter.sort === 'price-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
											<a onClick={this.handleFilterUpdate} href="#sort=price-descending">{ translate(setup, 'filterSortPriceDescending') }</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* Filter */}
					<div className={[s.filtering, (filterOpen ? s.filtering__open : null)].join(' ')}>
						<div className={s.filtering_title}>
							<a href="#open-filter" onClick={this.handleToggleDropdown}>
								<span>{ translate(setup, 'filterOpen') }</span>
								{
									filter.filteredBy.length > 1 && <span>{ `(${translate(setup, 'filterTotalItems').replace('%amount%', relevantProducts.length)})` }</span>
								}
							</a>
						</div>
						<div className={s.filtering_inner} style={{ height: screenHeight }}>
							<a className={s.filtering_inner_close} href="#close-filter" onClick={this.handleToggleDropdown}>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 1L1 13" stroke="black" />
									<path d="M1 1L13 13" stroke="black" />
								</svg>
							</a>
							{
								selectedGroup.length > 0 && (
									<a className={s.filtering_inner_back} href="#close-group" data-group={selectedGroup[0]} onClick={this.handleToggleGroup}>
										<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1 7L7 1" stroke="black" />
											<path d="M7 13L1 7" stroke="black" />
										</svg>
									</a>
								)
							}

							<div className={s.filtering_inner_chosenItems}>
								{
									filter.filteredBy.slice(1).map((fB) => {
										const [filterCategoryValue] = Object.keys(fB);

										if (typeof fB[filterCategoryValue] === 'boolean') {
											return (
												<a key={`selected${filterCategoryValue}`} className={s.filtering_inner_chosenItem} href={`#${filterCategoryValue}=1`} onClick={this.handleFilterUpdate}>
													{ translate(setup, filterCategoryValue) }
												</a>
											);
										}

										const filterCategory = filterDescriptions[filterCategoryValue];

										if (filterCategory && fB[filterCategoryValue].length > 0) {
											return fB[filterCategoryValue].map((fCV) => (
												<a key={`selected${filterCategoryValue}${fCV}`} className={s.filtering_inner_chosenItem} href={`#${filterCategoryValue}=${fCV}`} onClick={this.handleFilterUpdate}>
													{ filterCategory[fCV.split('___').pop()].text ? translate(setup, filterCategory[fCV.split('___').pop()].text) : filterCategory[fCV.split('___').pop()] }
												</a>
											));
										}

										return null;
									})
								}
							</div>

							{/* rise */}
							{
								Object.keys(rise).filter((r) => intersect(rise[r], relevantBaseProducts).length > 0).length > 0 && (
									<div className={[s.section, (selectedGroup.length > 0 && selectedGroup.indexOf('rise') === -1 ? s.section__hidden : null)].join(' ')}>
										<div className={[s.section_group, (this.state.rise ? s.section_group__open : null)].join(' ')}>
											<a className={s.section_group_title} href="#open-group" data-group="rise" onClick={this.handleToggleGroup}>
												<span>{ translate(setup, 'filterRise') }</span>
												<span>{`(${(filter.rise && filter.rise.map((r) => filterDescriptions.rise[r]).join(', ')) || translate(setup, 'filterGroupAll')})`}</span>
											</a>
											<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
												{
													Object.keys(rise).sort((a, b) => a.localeCompare(b)).map((r) => {
														if (intersect(rise[r], relevantBaseProducts).length === 0) return null;

														const linkClasses = [s.section_group_item];
														if (intersect(rise[r], (lastFilter === 'rise' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
														if (filter.rise && filter.rise.indexOf(r) !== -1) linkClasses.push(s.section_group_item__selected);

														return (
															<div key={r} className={linkClasses.join(' ')}>
																<a onClick={this.handleFilterUpdate} href={`#rise=${r}`}>
																	{ riseDescriptions[r] }
																</a>
															</div>
														);
													})
												}
											</div>
										</div>
									</div>
								)
							}

							{/* stretch */}
							{
								Object.keys(stretch).filter((r) => intersect(stretch[r], relevantBaseProducts).length > 0).length > 0 && (
									<div className={[s.section, (selectedGroup.length > 0 && selectedGroup.indexOf('stretch') === -1 ? s.section__hidden : null)].join(' ')}>
										<div className={[s.section_group, (this.state.stretch ? s.section_group__open : null)].join(' ')}>
											<a className={s.section_group_title} href="#open-group" data-group="stretch" onClick={this.handleToggleGroup}>
												<span>{ translate(setup, 'filterStretch') }</span>
												<span>{`(${(filter.stretch && filter.stretch.map((r) => filterDescriptions.stretch[r]).join(', ')) || translate(setup, 'filterGroupAll')})`}</span>
											</a>
											<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
												{
													Object.keys(stretch).sort((a, b) => a.localeCompare(b)).map((r) => {
														if (intersect(stretch[r], relevantBaseProducts).length === 0) return null;

														const linkClasses = [s.section_group_item];
														if (intersect(stretch[r], (lastFilter === 'stretch' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
														if (filter.stretch && filter.stretch.indexOf(r) !== -1) linkClasses.push(s.section_group_item__selected);

														return (
															<div key={r} className={linkClasses.join(' ')}>
																<a onClick={this.handleFilterUpdate} href={`#stretch=${r}`}>
																	{ stretchDescriptions[r] }
																</a>
															</div>
														);
													})
												}
											</div>
										</div>
									</div>
								)
							}

							{/* styles */}
							{
								Object.keys(styles).filter((style) => intersect(styles[style], relevantBaseProducts).length > 0).length > 0 && (
									<div className={[s.section, (selectedGroup.length > 0 && selectedGroup.indexOf('styles') === -1 ? s.section__hidden : null)].join(' ')}>
										<div className={[s.section_group, (this.state.styles ? s.section_group__open : null)].join(' ')}>
											<a className={s.section_group_title} href="#open-group" data-group="styles" onClick={this.handleToggleGroup}>
												<span>{ translate(setup, 'filterStyle') }</span>
												<span>{`(${filter.styles.map((style) => filterDescriptions.styles[style]).join(', ') || translate(setup, 'filterGroupAll')})`}</span>
											</a>
											<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
												{
													Object.keys(styles).sort((a, b) => a.localeCompare(b)).map((style) => {
														if (intersect(styles[style], relevantBaseProducts).length === 0) return null;

														const linkClasses = [s.section_group_item];
														if (intersect(styles[style], (lastFilter === 'styles' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
														if (filter.styles.indexOf(style) !== -1) linkClasses.push(s.section_group_item__selected);

														return (
															<div key={style} className={linkClasses.join(' ')}>
																<a onClick={this.handleFilterUpdate} href={`#styles=${style}`}>
																	{ styleDescriptions[style] }
																</a>
															</div>
														);
													})
												}
											</div>
										</div>
									</div>
								)
							}

							{/* colors */}
							<div className={[s.section, (selectedGroup.length > 0 && selectedGroup.indexOf('colors') === -1 ? s.section__hidden : null)].join(' ')}>
								<div className={[s.section_group, (this.state.colors ? s.section_group__open : null)].join(' ')}>
									<a className={s.section_group_title} href="#open-group" data-group="colors" onClick={this.handleToggleGroup}>
										<span>{ translate(setup, 'filterColor') }</span>
										<span>{`(${filter.colors.map((color) => filterDescriptions.colors[color].text).join(', ') || translate(setup, 'filterGroupAll')})`}</span>
									</a>
									<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
										{
											Object.keys(colors).sort((a, b) => (parseInt(colorDescriptions[a].order, 10) > parseInt(colorDescriptions[b].order, 10) ? 1 : -1)).map((color) => {
												if (intersect(colors[color], relevantBaseProducts).length === 0) return null;

												const linkClasses = [s.section_group_item];
												if (intersect(colors[color], (lastFilter === 'colors' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
												if (filter.colors.indexOf(color) !== -1) linkClasses.push(s.section_group_item__selected);

												return (
													<div key={color} className={linkClasses.join(' ')}>
														<a onClick={this.handleFilterUpdate} href={`#colors=${color}`}>
															{ colorDescriptions[color].text }
														</a>
													</div>
												);
											})
										}
									</div>
								</div>
							</div>

							{/* sizes */}
							<div className={[s.section, (selectedGroup.length > 0 && selectedGroup.indexOf('sizes') === -1 ? s.section__hidden : null)].join(' ')}>
								<div className={[s.section_group, (this.state.sizes ? s.section_group__open : null)].join(' ')}>
									<a className={s.section_group_title} href="#open-group" data-group="sizes" onClick={this.handleToggleGroup}>
										<span>{ translate(setup, 'filterSize') }</span>
										<span>{`(${filter.sizes.map((size) => filterDescriptions.sizes[size.split('___').pop()]).join(', ') || translate(setup, 'filterGroupAll')})`}</span>
									</a>
									{
										Object.keys(filterArrays.sizes).map((sizeGroup) => {
											const links = [];

											Object.keys(filterArrays.sizes[sizeGroup]).sort().forEach((size) => {
												if (intersect(filterArrays.sizes[sizeGroup][size], relevantBaseProducts).length === 0) return;

												const linkClasses = [s.section_group_item];
												if (intersect(filterArrays.sizes[sizeGroup][size], (lastFilter === 'sizes' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) {
													linkClasses.push(s.section_group_item__disabled);
												}
												if (filter.sizes.indexOf(`${sizeGroup}___${size}`) !== -1) linkClasses.push(s.section_group_item__selected);

												links.push((
													<div key={`${sizeGroup}___${size}`} className={linkClasses.join(' ')}>
														<a onClick={this.handleFilterUpdate} href={`#sizes=${sizeGroup}___${size}`}>
															<span>{ filterDescriptions.sizes[size] }</span>
														</a>
													</div>
												));
											});

											if (links.length === 0) return null;

											return (
												<div key={sizeGroup} className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
													{ links }
												</div>
											);
										})
									}
								</div>
							</div>

							{/* washes */}
							<div className={[s.section, (selectedGroup.length > 0 && selectedGroup.indexOf('washes') === -1 ? s.section__hidden : null)].join(' ')}>
								<div className={[s.section_group, (this.state.washes ? s.section_group__open : null)].join(' ')}>
									<a className={s.section_group_title} href="#open-group" data-group="washes" onClick={this.handleToggleGroup}>
										<span>{ translate(setup, 'filterWash') }</span>
										<span>{`(${filter.washes.map((wash) => filterDescriptions.washes[wash].text).join(', ') || translate(setup, 'filterGroupAll')})`}</span>
									</a>
									<div className={[s.section_group_items, s.section_group_items__swatch].join(' ')}>
										{
											Object.keys(washes).sort((a, b) => a.localeCompare(b)).map((wash) => {
												if (intersect(washes[wash], relevantBaseProducts).length === 0) return null;

												const linkClasses = [s.section_group_item];
												if (intersect(washes[wash], (lastFilter === 'washes' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
												if (filter.washes.indexOf(wash) !== -1) linkClasses.push(s.section_group_item__selected);

												return (
													<div key={wash} className={linkClasses.join(' ')}>
														<a onClick={this.handleFilterUpdate} href={`#washes=${wash}`}>
															{ washDescriptions[wash]?.image?.url && <span style={{ backgroundImage: `url(${washDescriptions[wash].image.url})` }} /> }
															<span>{ washDescriptions[wash].text }</span>
														</a>
													</div>
												);
											})
										}
									</div>
								</div>
							</div>

							{/* Apply / View */}
							{
								isFiltered && (
									<a className={s.section_apply} href="#view" onClick={this.resetFilterDropdowns}>
										<span>{ translate(setup, 'filterView') }</span>
										<span>{ translate(setup, 'filterTotalItems').replace('%amount%', relevantProducts.length) }</span>
									</a>
								)
							}
						</div>
					</div>
				</div>
				{
					relevantProducts.length > 0 ? (
						<div className={s.products}>
							<Pagination ListComponent={ListComponent} categoryTitles={filterDescriptions.categories} styleFilter={styleFilter} list={relevantProducts} cache={products} currentPath={prefix(setup, currentPath)} currentHash="" collectionSections={collectionSections} contentOffset={contentOffset} isFiltered={isFiltered} />
						</div>
					) : (
						<div className={s.filter_empty}>
							<h1 className={s.filter_empty_title}>{ relevantBaseProducts.length > 0 ? translate(setup, 'filterNoResults') : translate(setup, 'filterNoResultsNoFilter') }</h1>
							{
								filter.filteredBy.map((filterObj) => (
									Object.keys(filterObj).map((filterKey) => {
										if (Array.isArray(filterObj[filterKey])) {
											return filterObj[filterKey].map((filterItem) => {
												let title = filterDescriptions[filterKey][filterItem];
												if (filterKey === 'colors') title = colorDescriptions[filterItem];
												if (filterKey === 'sizes') title = filterDescriptions[filterKey][filterItem.slice(filterItem.indexOf('___') + 3)];
												return <a className={s.filter_empty_link} href={`#${filterKey}=${filterItem}`} onClick={this.handleFilterUpdate}>{ title }</a>;
											});
										}
										return <a className={s.filter_empty_link} href={`#${filterKey}=1`} onClick={this.handleFilterUpdate}>{ translate(setup, `filter${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`) }</a>;
									})
								))
							}
						</div>
					)
				}
			</div>
		);
	}
}

const mapState = ({ filter }, { ListComponent, data, filtering, setup, currentPath, productUri = false }) => ({
	filter,
	ListComponent,
	data,
	filtering,
	setup,
	currentPath,
	productUri,
});

export default hot(module)(connect(mapState, { updateFilter, resetFilter, clearFilter, updatePagination })(Filter));
